module.exports = __webpack_public_path__ + "static/media/dianrelan_banner_road.18134fd9.png";